import { RootState } from '../store';

export const selectAccount = (state: RootState) => state.account.accountData;
export const selectAccountLoaded = (state: RootState) => state.account.loaded;
export const selectAccountError = (state: RootState) => state.account.error;